<template>
  <v-main class="login-page">
    <v-card>
      <h1 class="display-1 mb-5">Heppi Suporte</h1>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <v-text-field
          label="E-mail"
          v-model="fields.email.value"
          :rules="[...fields.email.rules, ...fields.email.apiErrors]"
          type="email"
          outlined dense
        ></v-text-field>
        <v-text-field
          label="Senha"
          v-model="fields.password.value"
          :rules="[...fields.password.rules, ...fields.password.apiErrors]"
          type="password"
          outlined dense
        ></v-text-field>
        <v-btn block color="primary" :disabled="sending" :loading="sending" @click="sendLogin()">Entrar</v-btn>
        <br>
        <v-btn block text color="primary" :disabled="sending" :to="{ name: 'forgotPassword' }">Esqueci a senha</v-btn>
      </v-form>
    </v-card>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'login',
  data: () => ({
    fields: {
      email: {
        value: '',
        rules: [
          v => !!v || 'O e-mail é obrigatório',
          v => /.+@.+\..+/.test(v) || 'Precisa ser um e-mail válido'
        ],
        apiErrors: []
      },
      password: {
        value: '',
        rules: [
          v => !!v || 'A senha é obrigatória'
        ],
        apiErrors: []
      }
    },
    sending: false,
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    }
  },
  methods: {
    ...mapMutations(['SET_USER']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    sendLogin () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null

        axios.post('login', vue.apiData)
          .then(response => {
            vue.SET_USER({ ...response.data, email: vue.fields.email.value })
            vue.sending = false
            vue.$router.push({ name: 'home' })
          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              vue.errorMessage = 'Usuário e senha não conferem'
            } else if (error.response && error.response.status === 422) {
              if (error.response.data) vue.generateApiErrors(error.response.data)
              vue.errorMessage = 'Verifique os campos com erro'
            } else {
              vue.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
            }
            vue.sending = false
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    }
  }
}
</script>
